import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SafeHtml from 'epic-react-common/src/components/SafeHtml';

const CharacterItem = ({active, thumbnail, name, unlock, description, onClick}) => {
    return (
        <div className={classNames('character-item', active && 'active')}>
            <button
                onClick={onClick}
                style={{backgroundImage: `url('${thumbnail}')`}}
            />
            <div className="tool-tip">
                <b>{name}</b>
                <p>{unlock}</p>
                <SafeHtml
                    element="p"
                    dangerouslySetInnerHTML={{ __html: description}} />
            </div>
        </div>
    )
}

CharacterItem.propTypes = {
    active: PropTypes.bool,
    thumbnail: PropTypes.string,
    name: PropTypes.string,
    unlock: PropTypes.string,
    description: PropTypes.string,
    onClick: PropTypes.func
}

CharacterItem.defaultProps = {
    active: false,
    thumbnail: '',
    name: '',
    unlock: '',
    description: '',
    onClick: fn => fn
};

export default CharacterItem;
